import { service } from "@server/client";
import type {
  AddToCartMutation,
  AddToCartMutationVariables,
} from "@server/gql/graphql";
import { addToCartMutation } from "@server/queries/cart";

export const addToCart = async (variables: AddToCartMutationVariables) => {
  try {
    const response = await service<
      AddToCartMutation,
      AddToCartMutationVariables
    >({
      query: addToCartMutation,
      variables,
    });

    return response.cart;
  } catch (error: Error | unknown) {
    console.error("Error in addToCart", error);
    throw error;
  }
};
